export const themeColors: any = {
  primary: '#000',
  heading: ' #000',
  text: '#272727',
  comment: '#D4FFFF',
};
export const careenContentApp: any = {
  projectName: 'Indianpix',
  bannerContent:
    'Mantra being- “Early birds or night owls- getting the work done is what counts”',
  cultureContent:
    'In a nutshell, we n and acknowledge people on the basis of their quality of work. We have a solid culture where we believe in each other and work towards a common goal of delivering good quality results in a given time frame.',
  hrEmail: 'hello@indianpix.co',
};
export const jobOpening: any = [
  {
    designation: 'UI/UX Designer',
    location: 'Pune',
  },
  {
    designation: 'React Developer',
    location: 'Pune',
  },
];
export const socialLinks: any = {
  facebook: 'https://www.facebook.com/indianpix.agency',
  instagram: 'https://www.instagram.com/indianpix.design/',
  linkdin: 'https://www.linkedin.com/in/indian-pix-13b533209',
};
